// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Symbol Search Styles - CSS Module */
._Dt9JTqSZnftA5GvqxWh {
  position: relative;
  min-width: min(380px, 100%);
  flex: 1 1 380px;
}

.hpa5jrcqtJwHiDf_UC0g {
  width: 100%;
  box-sizing: border-box;
  border: 1.5px solid var(--vnsc-border, #3a3e49);
  background: var(--vnsc-surface, #1e222d);
  color: var(--vnsc-text, #f8fafc);
  font: inherit;
  font-size: 12px;
  line-height: 1.4;
  padding: 8px 10px;
  border-radius: 6px;
  outline: none;
  transition: border-color 100ms ease, box-shadow 100ms ease;
}

.hpa5jrcqtJwHiDf_UC0g::placeholder {
  color: var(--vnsc-text-secondary, #787b86);
  opacity: 0.85;
}

.hpa5jrcqtJwHiDf_UC0g:focus {
  border-color: var(--vnsc-accent, #6366f1);
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);
}

.QiyIQSHv6MEBt1kv9Bfz {
  position: absolute;
  z-index: 1000;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--vnsc-accent, #6366f1);
  border-radius: 10px;
  background: var(--vnsc-bg-primary, #1e222d);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);
  max-height: min(60vh, 600px);
  overflow: auto;
}

.QiyIQSHv6MEBt1kv9Bfz ul {
  margin: 0;
  padding: 6px;
  list-style: none;
}

.xiQGGE29h5Oz_lo6uMwX {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  color: var(--vnsc-text-secondary);
  font-size: 12px;
  transition: background 100ms ease, color 100ms ease;
}

.xiQGGE29h5Oz_lo6uMwX:hover,
.WHO32CplZ2ZOy5lpJdYz {
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-primary);
}

/* Compare dialog: row matching the main chart symbol — cannot compare against itself. */
.AmmNn_huxDwoz_YLdUih,
.AmmNn_huxDwoz_YLdUih:hover {
  opacity: 0.45;
  cursor: not-allowed;
  background: transparent;
}

.yD5xnIt1kthSdV7uI8pJ {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid var(--vnsc-border, #3a3e49);
  color: var(--vnsc-text-secondary);
  white-space: nowrap;
}

.GOmVi0rAcqmj1DQvK5N9 {
  font-weight: 700;
  color: inherit;
}

.GHBH3TDQiuVudyoSmCHh {
  font-size: 11px;
  color: inherit;
}

.Yu9FcCn4xC5tNfOcr51v {
  display: flex;
  gap: 4px;
  padding: 6px 8px 4px;
  border-bottom: 1px solid var(--vnsc-border);
}

.LPMzP8EQCrkho3qTSbow {
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border);
  background: transparent;
  color: var(--vnsc-text-secondary);
  font-size: 11px;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
}

.LPMzP8EQCrkho3qTSbow:hover {
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-primary);
}

.BlPtILKOyAgZt_5wM06w {
  background: var(--vnsc-accent, #2962ff);
  border-color: var(--vnsc-accent, #2962ff);
  color: #fff;
}

._C5f0gvLqgYcsuAvrCLs {
  font-size: 9px;
  font-weight: 700;
  padding: 1px 4px;
  border-radius: 3px;
  background: var(--vnsc-bg-tertiary);
  color: var(--vnsc-text-secondary);
  flex-shrink: 0;
}

.xAFHBaNpQjs9co43HdJ9 {
  background: color-mix(in srgb, var(--vnsc-color-success) 18%, transparent);
  color: var(--vnsc-color-success);
}

.Fob8AtH5a6fn3LY7obPK {
  background: color-mix(in srgb, var(--vnsc-color-info) 18%, transparent);
  color: var(--vnsc-color-info);
}

.qvJ2gi6SmFGZUaf1i9Rd {
  background: color-mix(in srgb, var(--vnsc-color-warning) 18%, transparent);
  color: var(--vnsc-color-warning);
}

.IDpLJFxwjriHvSNgGggP {
  padding: 6px 8px 4px;
}

.IDpLJFxwjriHvSNgGggP + .IDpLJFxwjriHvSNgGggP {
  border-top: 1px solid var(--vnsc-border);
}

.RPwIzRy1GejTf6GKhBl7 {
  font-size: 10px;
  font-weight: 700;
  color: var(--vnsc-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 5px;
}

.Kw_oC7i5qU9UC_T6QXfy {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.pIkilWBXguD6QoQ3ZPO7 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid var(--vnsc-border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--vnsc-text-primary);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}

.pIkilWBXguD6QoQ3ZPO7:hover {
  background: var(--vnsc-bg-tertiary);
}

.PUyKjs152BST6KAOH8lg {
  border-color: color-mix(in srgb, var(--vnsc-color-success) 35%, transparent);
  color: var(--vnsc-color-success);
}

.PUyKjs152BST6KAOH8lg:hover {
  background: color-mix(in srgb, var(--vnsc-color-success) 12%, transparent);
}

.YnspYzSpjB_tLLL_2L_Y {
  border-color: color-mix(in srgb, var(--vnsc-color-info) 35%, transparent);
  color: var(--vnsc-color-info);
}

.YnspYzSpjB_tLLL_2L_Y:hover {
  background: color-mix(in srgb, var(--vnsc-color-info) 12%, transparent);
}

.WwcGTVmEuhUgmyVyyeSG {
  border-color: color-mix(in srgb, var(--vnsc-color-warning) 35%, transparent);
  color: var(--vnsc-color-warning);
}

.WwcGTVmEuhUgmyVyyeSG:hover {
  background: color-mix(in srgb, var(--vnsc-color-warning) 12%, transparent);
}

.imnSlt7iA7AFXGzLtNh9 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  margin-top: 4px;
}

.Xhql1DgIB08bZIuCIhqm {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 12px;
}

.JpgTxCZpYRmhD_ZimKk8,
._RU0TSF01Hghp1cYrOPo {
  font-size: 12px;
  color: var(--vnsc-text-secondary);
}

/* Color dot for compare mode */
.Z2mve4O2qiPjH37nqEGF {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* Overlay row for existing compared symbols in compare mode */
._fl5kwRUlQJCKFJj0daK {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.Cyq_Ioqy0JabtdbV0fIT {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

/* Compare mode action buttons within dropdown */
.VSqJtaqEFJd0mgs1xXff {
  padding: 2px 8px;
  border: 1px solid color-mix(in srgb, var(--vnsc-color-success) 40%, transparent);
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-color-success);
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.VSqJtaqEFJd0mgs1xXff:hover {
  background: color-mix(in srgb, var(--vnsc-color-success) 10%, transparent);
}

._sqBXiFnYiZl3U1Xaikw {
  padding: 2px 8px;
  border: 1px solid color-mix(in srgb, var(--vnsc-color-bearish) 40%, transparent);
  border-radius: 4px;
  background: transparent;
  color: var(--vnsc-color-bearish);
  font-size: 11px;
  cursor: pointer;
  flex-shrink: 0;
}

._sqBXiFnYiZl3U1Xaikw:hover {
  background: color-mix(in srgb, var(--vnsc-color-bearish) 10%, transparent);
}

.O0dvxSicYZ1HhI_mKH0t {
  margin: 0;
  border: none;
  border-top: 1px solid var(--vnsc-border, #3a3e49);
}

@media (max-width: 480px) {
  ._Dt9JTqSZnftA5GvqxWh {
    min-width: 100%;
  }
  
  .QiyIQSHv6MEBt1kv9Bfz {
    left: 0;
    right: 0;
    max-height: 50vh;
  }
}

/* Symbol Search Modal (P2-c): centered TradingView-style dialog */
.wuhpVErB5XssZd7fWaKF {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12vh 16px 16px;
  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.oBuWFgfh1jtOJfIoDUrT {
  width: min(640px, 100%);
  max-height: 70vh;
  overflow: auto;
  border: 1px solid var(--vnsc-accent, #6366f1);
  border-radius: 12px;
  background: var(--vnsc-bg-modal, #1e222d);
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);
}

/* Flat in-flow results for modal embedding (HOTFIX): the modal panel already
   provides border/background, so the results must NOT float absolute inside it. */
.o7z9Kv5Z8V7TU9FdkQPX {
  position: static;
  z-index: auto;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  max-height: none;
  overflow: visible;
}

.o7z9Kv5Z8V7TU9FdkQPX ul {
  margin: 0;
  padding: 6px 0 0;
  list-style: none;
}

/* Unified row actions (P2): Switch (primary) + Compare (ghost) per result */
.uhcyH0_UM2OPOtBgk7zH {
  display: inline-flex;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
}

._865Ge6_xuhIu6hv7rSWA {
  color: #fff;
  border-color: var(--vnsc-accent, #6366f1);
  background: rgba(99, 102, 241, 0.15);
}

._865Ge6_xuhIu6hv7rSWA:hover {
  background: rgba(99, 102, 241, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/widget/styles/symbol-search.module.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,+CAA+C;EAC/C,wCAAwC;EACxC,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,6CAA6C;EAC7C,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,8EAA8E;EAC9E,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,mDAAmD;AACrD;;AAEA;;EAEE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,wFAAwF;AACxF;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,6CAA6C;EAC7C,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,0EAA0E;EAC1E,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4EAA4E;EAC5E,gCAAgC;AAClC;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,yEAAyE;EACzE,6BAA6B;AAC/B;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,4EAA4E;EAC5E,gCAAgC;AAClC;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,gFAAgF;EAChF,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,gBAAgB;EAChB,gFAAgF;EAChF,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,0DAA0D;EAC1D,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,mBAAmB;EACnB,yCAAyC;EACzC,8EAA8E;AAChF;;AAEA;kFACkF;AAClF;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* Symbol Search Styles - CSS Module */\r\n.wrapper {\r\n  position: relative;\r\n  min-width: min(380px, 100%);\r\n  flex: 1 1 380px;\r\n}\r\n\r\n.input {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 1.5px solid var(--vnsc-border, #3a3e49);\r\n  background: var(--vnsc-surface, #1e222d);\r\n  color: var(--vnsc-text, #f8fafc);\r\n  font: inherit;\r\n  font-size: 12px;\r\n  line-height: 1.4;\r\n  padding: 8px 10px;\r\n  border-radius: 6px;\r\n  outline: none;\r\n  transition: border-color 100ms ease, box-shadow 100ms ease;\r\n}\r\n\r\n.input::placeholder {\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n  opacity: 0.85;\r\n}\r\n\r\n.input:focus {\r\n  border-color: var(--vnsc-accent, #6366f1);\r\n  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2);\r\n}\r\n\r\n.dropdown {\r\n  position: absolute;\r\n  z-index: 1000;\r\n  top: calc(100% + 6px);\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  border: 1px solid var(--vnsc-accent, #6366f1);\r\n  border-radius: 10px;\r\n  background: var(--vnsc-bg-primary, #1e222d);\r\n  backdrop-filter: blur(16px);\r\n  -webkit-backdrop-filter: blur(16px);\r\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);\r\n  max-height: min(60vh, 600px);\r\n  overflow: auto;\r\n}\r\n\r\n.dropdown ul {\r\n  margin: 0;\r\n  padding: 6px;\r\n  list-style: none;\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 10px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: 12px;\r\n  transition: background 100ms ease, color 100ms ease;\r\n}\r\n\r\n.item:hover,\r\n.itemHighlighted {\r\n  background: var(--vnsc-bg-tertiary);\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n/* Compare dialog: row matching the main chart symbol — cannot compare against itself. */\r\n.itemDisabled,\r\n.itemDisabled:hover {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n  background: transparent;\r\n}\r\n\r\n.currentBadge {\r\n  margin-left: auto;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  border: 1px solid var(--vnsc-border, #3a3e49);\r\n  color: var(--vnsc-text-secondary);\r\n  white-space: nowrap;\r\n}\r\n\r\n.symbol {\r\n  font-weight: 700;\r\n  color: inherit;\r\n}\r\n\r\n.name {\r\n  font-size: 11px;\r\n  color: inherit;\r\n}\r\n\r\n.exchangeBar {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 6px 8px 4px;\r\n  border-bottom: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.exBtn {\r\n  padding: 2px 8px;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--vnsc-border);\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary);\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s;\r\n}\r\n\r\n.exBtn:hover {\r\n  background: var(--vnsc-bg-tertiary);\r\n  color: var(--vnsc-text-primary);\r\n}\r\n\r\n.exBtnActive {\r\n  background: var(--vnsc-accent, #2962ff);\r\n  border-color: var(--vnsc-accent, #2962ff);\r\n  color: #fff;\r\n}\r\n\r\n.exBadge {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  padding: 1px 4px;\r\n  border-radius: 3px;\r\n  background: var(--vnsc-bg-tertiary);\r\n  color: var(--vnsc-text-secondary);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.exBadgeHose {\r\n  background: color-mix(in srgb, var(--vnsc-color-success) 18%, transparent);\r\n  color: var(--vnsc-color-success);\r\n}\r\n\r\n.exBadgeHnx {\r\n  background: color-mix(in srgb, var(--vnsc-color-info) 18%, transparent);\r\n  color: var(--vnsc-color-info);\r\n}\r\n\r\n.exBadgeUpcom {\r\n  background: color-mix(in srgb, var(--vnsc-color-warning) 18%, transparent);\r\n  color: var(--vnsc-color-warning);\r\n}\r\n\r\n.section {\r\n  padding: 6px 8px 4px;\r\n}\r\n\r\n.section + .section {\r\n  border-top: 1px solid var(--vnsc-border);\r\n}\r\n\r\n.sectionLabel {\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  color: var(--vnsc-text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.chipRow {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 24px;\r\n  padding: 0 8px;\r\n  box-sizing: border-box;\r\n  border-radius: 4px;\r\n  border: 1px solid var(--vnsc-border);\r\n  background: rgba(255, 255, 255, 0.03);\r\n  color: var(--vnsc-text-primary);\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background 120ms ease, border-color 120ms ease;\r\n}\r\n\r\n.chip:hover {\r\n  background: var(--vnsc-bg-tertiary);\r\n}\r\n\r\n.chipVn30 {\r\n  border-color: color-mix(in srgb, var(--vnsc-color-success) 35%, transparent);\r\n  color: var(--vnsc-color-success);\r\n}\r\n\r\n.chipVn30:hover {\r\n  background: color-mix(in srgb, var(--vnsc-color-success) 12%, transparent);\r\n}\r\n\r\n.chipFutures {\r\n  border-color: color-mix(in srgb, var(--vnsc-color-info) 35%, transparent);\r\n  color: var(--vnsc-color-info);\r\n}\r\n\r\n.chipFutures:hover {\r\n  background: color-mix(in srgb, var(--vnsc-color-info) 12%, transparent);\r\n}\r\n\r\n.chipCrypto {\r\n  border-color: color-mix(in srgb, var(--vnsc-color-warning) 35%, transparent);\r\n  color: var(--vnsc-color-warning);\r\n}\r\n\r\n.chipCrypto:hover {\r\n  background: color-mix(in srgb, var(--vnsc-color-warning) 12%, transparent);\r\n}\r\n\r\n.vn30Grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr);\r\n  gap: 6px;\r\n  margin-top: 4px;\r\n}\r\n\r\n.emptyState {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px 12px;\r\n}\r\n\r\n.emptyText,\r\n.loadingText {\r\n  font-size: 12px;\r\n  color: var(--vnsc-text-secondary);\r\n}\r\n\r\n/* Color dot for compare mode */\r\n.colorDot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Overlay row for existing compared symbols in compare mode */\r\n.overlayRow {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 4px 0;\r\n}\r\n\r\n.overlayRowLeft {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n/* Compare mode action buttons within dropdown */\r\n.addBtn {\r\n  padding: 2px 8px;\r\n  border: 1px solid color-mix(in srgb, var(--vnsc-color-success) 40%, transparent);\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-color-success);\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.addBtn:hover {\r\n  background: color-mix(in srgb, var(--vnsc-color-success) 10%, transparent);\r\n}\r\n\r\n.removeBtn {\r\n  padding: 2px 8px;\r\n  border: 1px solid color-mix(in srgb, var(--vnsc-color-bearish) 40%, transparent);\r\n  border-radius: 4px;\r\n  background: transparent;\r\n  color: var(--vnsc-color-bearish);\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.removeBtn:hover {\r\n  background: color-mix(in srgb, var(--vnsc-color-bearish) 10%, transparent);\r\n}\r\n\r\n.divider {\r\n  margin: 0;\r\n  border: none;\r\n  border-top: 1px solid var(--vnsc-border, #3a3e49);\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .wrapper {\r\n    min-width: 100%;\r\n  }\r\n  \r\n  .dropdown {\r\n    left: 0;\r\n    right: 0;\r\n    max-height: 50vh;\r\n  }\r\n}\r\n\r\n/* Symbol Search Modal (P2-c): centered TradingView-style dialog */\r\n.modalBackdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 5000;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  padding: 12vh 16px 16px;\r\n  background: var(--vnsc-bg-overlay, rgba(10, 14, 20, 0.85));\r\n  backdrop-filter: blur(2px);\r\n  -webkit-backdrop-filter: blur(2px);\r\n}\r\n\r\n.modalPanel {\r\n  width: min(640px, 100%);\r\n  max-height: 70vh;\r\n  overflow: auto;\r\n  border: 1px solid var(--vnsc-accent, #6366f1);\r\n  border-radius: 12px;\r\n  background: var(--vnsc-bg-modal, #1e222d);\r\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6), 0 0 0 2px rgba(99, 102, 241, 0.15);\r\n}\r\n\r\n/* Flat in-flow results for modal embedding (HOTFIX): the modal panel already\r\n   provides border/background, so the results must NOT float absolute inside it. */\r\n.dropdownFlat {\r\n  position: static;\r\n  z-index: auto;\r\n  margin: 8px 0 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  border: 0;\r\n  border-radius: 0;\r\n  background: transparent;\r\n  box-shadow: none;\r\n  backdrop-filter: none;\r\n  -webkit-backdrop-filter: none;\r\n  max-height: none;\r\n  overflow: visible;\r\n}\r\n\r\n.dropdownFlat ul {\r\n  margin: 0;\r\n  padding: 6px 0 0;\r\n  list-style: none;\r\n}\r\n\r\n/* Unified row actions (P2): Switch (primary) + Compare (ghost) per result */\r\n.unifiedRowActions {\r\n  display: inline-flex;\r\n  gap: 4px;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.switchBtn {\r\n  color: #fff;\r\n  border-color: var(--vnsc-accent, #6366f1);\r\n  background: rgba(99, 102, 241, 0.15);\r\n}\r\n\r\n.switchBtn:hover {\r\n  background: rgba(99, 102, 241, 0.3);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `_Dt9JTqSZnftA5GvqxWh`,
	"input": `hpa5jrcqtJwHiDf_UC0g`,
	"dropdown": `QiyIQSHv6MEBt1kv9Bfz`,
	"item": `xiQGGE29h5Oz_lo6uMwX`,
	"itemHighlighted": `WHO32CplZ2ZOy5lpJdYz`,
	"itemDisabled": `AmmNn_huxDwoz_YLdUih`,
	"currentBadge": `yD5xnIt1kthSdV7uI8pJ`,
	"symbol": `GOmVi0rAcqmj1DQvK5N9`,
	"name": `GHBH3TDQiuVudyoSmCHh`,
	"exchangeBar": `Yu9FcCn4xC5tNfOcr51v`,
	"exBtn": `LPMzP8EQCrkho3qTSbow`,
	"exBtnActive": `BlPtILKOyAgZt_5wM06w`,
	"exBadge": `_C5f0gvLqgYcsuAvrCLs`,
	"exBadgeHose": `xAFHBaNpQjs9co43HdJ9`,
	"exBadgeHnx": `Fob8AtH5a6fn3LY7obPK`,
	"exBadgeUpcom": `qvJ2gi6SmFGZUaf1i9Rd`,
	"section": `IDpLJFxwjriHvSNgGggP`,
	"sectionLabel": `RPwIzRy1GejTf6GKhBl7`,
	"chipRow": `Kw_oC7i5qU9UC_T6QXfy`,
	"chip": `pIkilWBXguD6QoQ3ZPO7`,
	"chipVn30": `PUyKjs152BST6KAOH8lg`,
	"chipFutures": `YnspYzSpjB_tLLL_2L_Y`,
	"chipCrypto": `WwcGTVmEuhUgmyVyyeSG`,
	"vn30Grid": `imnSlt7iA7AFXGzLtNh9`,
	"emptyState": `Xhql1DgIB08bZIuCIhqm`,
	"emptyText": `JpgTxCZpYRmhD_ZimKk8`,
	"loadingText": `_RU0TSF01Hghp1cYrOPo`,
	"colorDot": `Z2mve4O2qiPjH37nqEGF`,
	"overlayRow": `_fl5kwRUlQJCKFJj0daK`,
	"overlayRowLeft": `Cyq_Ioqy0JabtdbV0fIT`,
	"addBtn": `VSqJtaqEFJd0mgs1xXff`,
	"removeBtn": `_sqBXiFnYiZl3U1Xaikw`,
	"divider": `O0dvxSicYZ1HhI_mKH0t`,
	"modalBackdrop": `wuhpVErB5XssZd7fWaKF`,
	"modalPanel": `oBuWFgfh1jtOJfIoDUrT`,
	"dropdownFlat": `o7z9Kv5Z8V7TU9FdkQPX`,
	"unifiedRowActions": `uhcyH0_UM2OPOtBgk7zH`,
	"switchBtn": `_865Ge6_xuhIu6hv7rSWA`
};
export default ___CSS_LOADER_EXPORT___;
